import {
  concretiseParams,
  updateSearchParamsWithFilters,
} from "../filters/filters"
import { updateSearchParamsWithPagination } from "../../page"
import { API_BASE_URL } from "../../app/config"
import { getToken, handleSignIn } from "../iam/middleware"

/**
 * Get astrosite states
 * The states are a snapshots of various properties of the astrosite including location info, temp wind readings, etc
 * @param filers  // filters to apply
 * @param page  // pagination settings
 * @returns {Promise<any>}
 */
export const getAstrositesState = async ({ filter = {}, page = {} }) => {
  // Build parameter set
  const params = new URLSearchParams()
  updateSearchParamsWithFilters(params, filter)
  // Replace any relative ones with absolute ones
  concretiseParams(params)
  // Pagination control
  updateSearchParamsWithPagination(params, page)

  let resp = await fetch(
    `${API_BASE_URL}/api/astrosites/state?${params.toString()}`,
    {
      method: "GET",
      mode: "cors",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      redirect: "error",
    }
  )

  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Get a latest sunrise and sunset at an Astrosite
 * TODO this service is not ported yet (leaving the front end code in for when its done)
 * TODO As we no longer have a python backend we will need to use the Java libs
 * @param submissionId
 * @returns {Promise<any>}
 */
export const getAstrositeSunInfo = async (astrositeId) => {
  let resp = await fetch(
    `${API_BASE_URL}/api/astrosites/${astrositeId}/suninfo`,
    {
      method: "GET",
      mode: "cors",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      redirect: "error",
    }
  )

  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Get astrosites matching the provided filters
 * @param filers  // filters to apply
 * @param page  // pagination settings
 * @returns {Promise<any>}
 */
export const getAstrosites = async ({ filter = {}, page = {} }) => {
  // Build parameter set
  const params = new URLSearchParams()
  updateSearchParamsWithFilters(params, filter)
  // Replace any relative ones with absolute ones
  concretiseParams(params)
  // Pagination control
  updateSearchParamsWithPagination(params, page)

  let resp = await fetch(
    `${API_BASE_URL}/api/astrosites?${params.toString()}`,
    {
      method: "GET",
      mode: "cors",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      redirect: "error",
    }
  )

  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Get an Astrosite by its ID
 * @param id
 * @returns {Promise<any>}
 */
export const getAstrositeById = async (id) => {
  let resp = await fetch(`${API_BASE_URL}/api/astrosites/${id}`, {
    method: "GET",
    mode: "cors",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    redirect: "error",
  })

  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Set auto activation flag for an Astrosite
 * @param id
 * @param autoActivation a bool indicating the auto-activation
 * @param _etag this comes from the retrieve request and is used to support optimistic concurrency
 * @returns {Promise<any>}
 */
export const setAstrositeAutoActivation = async ({
  id,
  autoActivate = false,
  _etag,
}) => {
  let resp = await fetch(
    `${API_BASE_URL}/api/astrosites/${id}/auto-activation`,
    {
      method: "PUT",
      mode: "cors",
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
        auto_activate: autoActivate,
        _etag: _etag,
      }),
      redirect: "error",
    }
  )
  resp = handleSignIn(resp)
  return resp.json()
}
